import { createFileRoute } from '@tanstack/react-router'
import { HomeScreen } from '../features/home'

// No loader: each Today card and the conversation load (and fail) on their own, so one slow section never blanks Home.
export const Route = createFileRoute('/')({
  component: HomeScreen,
})
